<template>
  <div>
    <sub-page :active-names="activeNames" :list="menu" @selectItem="selectItem">
      <template slot="left-content">
        <div class="context" v-html="br(showDate.content)"></div>
      </template>
    </sub-page>
  </div>
</template>

<script>
import SubPage from '../../components/Subpage/subpage'
import { myMixin } from '../../mixin'
import HomeApi from '../../network/home'
import { program_type, content_type } from '../../common/enum/imgEnum'
import toTree from '../../utils/generateTree'

export default {
  name: 'Regard',
  components: {
    SubPage
  },
  mixins: [myMixin],
  data() {
    return {
      activeNames: 'compony',
      showDate: {},
      menu: [],
      regard: []
    }
  },
  async created() {
    await this._getRegard()
    this.showDate = this.regard[1]
  },
  methods: {
    selectItem(e) {
      const show = this.regard.find((item) => {
        return item.id === e
      })
      this.regard.find((item) => item.id === e)
      this.showDate = show
    },

    // 获取关于我们数据
    async _getRegard() {
      const result = await HomeApi.getContent(
        program_type.official_website,
        content_type.aboutUs
      )
      this.regard = result.data
      const narr = this.arrGetName(JSON.parse(JSON.stringify(result.data)))
      const arr = toTree(narr)
      this.menu = arr
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 100px;
  background-color: rgb(0, 113, 193);
}

.regard {
  width: 1200px;
  margin: auto;
  margin-bottom: 100px;
}

.container {
  display: flex;
  padding: 50px 0;
}

.menu {
  width: 160px;
  cursor: pointer;
}

.menu-item {
  padding: 10px;
  cursor: pointer;
}

.title {
  font-size: 20px;
  font-weight: 700;
  color: blue;
}

.left {
  padding: 0 30px;
}

.right {
  width: 100%;
}
</style>
